export enum InstrumentTypes {
  Options = "options",
  Perps = "perps",
}
export type InstrumentType = `${InstrumentTypes}`;

export type TradeDirection = "buy" | "sell";
export type TradeType = "market" | "limit" | "rfq";
export type OrderSide = "ask" | "bid"; // used for unit tests, FE generally uses buy/sell
